var common = {
  'message.error.xml2json': 'XMLをJSONに変換できませんでした。XMLの形式を確認してください。'
};
export { common as default };
